<template>
  <!-- Add point steps container -->
  <div class="absolute pin-b pin-r pin-l w-full max-h-90 bg-brand overflow-scroll z-30
              md:pin-none md:pin-t md:pin-l md:w-2/5 md:max-w-sm md:ml-4 md:mt-4 md:rounded md:shadow">

    <ConsentStep v-if="currentState == 'consent'" key="consent"></ConsentStep>
    <AddPointStep v-if="currentState == 'addPoint'" key="addPoint"></AddPointStep>
    <ConfirmPointStep v-else-if="currentState == 'waitingForPointConfirmation'" key="confirmPoint"></ConfirmPointStep>
    <ImageUploadStep v-else-if="currentState == 'imageUpload'" key="imageUpload"></ImageUploadStep>
    <PointSavedStep v-else-if="currentState == 'pointSaved'" key="pointSaved"></PointSavedStep>

  </div>

</template>

<script>
import { mapGetters } from "vuex";

// Add yourself steps
import ConsentStep from "../components/ConsentStep";
import AddPointStep from "../components/AddPointStep";
import ConfirmPointStep from "../components/ConfirmPointStep";
import ImageUploadStep from "../components/ImageUploadStep";
import PointSavedStep from "../components/PointSavedStep";

export default {
  components: {
    ConsentStep,
    AddPointStep,
    ConfirmPointStep,
    PointSavedStep,
    ImageUploadStep
  },
  data() {
    return {
      userResponses: {
        name: "",
        occupation: "",
        latlng: [],
        answers: [
          {
            question: "Are you optimistic or pessimistic about the future?",
            answer: ""
          },
          {
            question:
              "What experiences in nature and society have inspired you in your local area?",
            answer: ""
          },
          {
            question: "What is the most vital element of your work?",
            answer: ""
          },
          {
            question: "What does a good life depend upon?",
            answer: ""
          }
        ],
        currentQuestion: 0
      }
    };
  },
  computed: {
    ...mapGetters(["currentState", "newPoint"]),
    currentYear() {
      return this.$route.params.year;
    }
  },
  methods: {}
};
</script>




// WEBPACK FOOTER //
// AddPointView.vue?dcab3ad4